import type React from 'react';
import { useEffect } from 'react';

const useClickOutside = (
  ref: React.MutableRefObject<HTMLElement | null>,
  outsideClickHandler: () => void
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Trigger the handler only if clicking outside of the ref's element
      if (ref.current && !ref.current.contains(event.target as Node)) {
        outsideClickHandler();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, outsideClickHandler]); // Include outsideClickHandler in dependencies
};

export default useClickOutside;
